import { Card, Col, Typography } from 'antd';
import { styled } from 'styled-components';

export const StyledCard = styled(Card)`
  box-shadow: 0px 0px 15px 0px #e7eaf6;
  border: 1px solid #f4f4f4;
`;

export const DetailsBody = styled.div``;

export const ChartCol = styled(Col)``;

export const StyledInfo = styled(Typography.Text)``;

export const ChartContainer = styled.div`
  position: relative;
  height: 500px;
  width: 100%;
  .chartdiv {
    width: 100%;
    height: 90%;
  }
  /* &::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 64px;
    background: white;
    bottom: 0;
  } */
`;
